import "../../../../../../vue@3.5.18_typescript@5.2.2/node_modules/vue/dist/vue.runtime.esm-bundler.js";
import { useRtl as K } from "../../_mixins/use-rtl.js";
import L from "./styles/radio-group.cssr.js";
import { radioGroupInjectionKey as M } from "./use-radio.js";
import q from "../../_mixins/use-form-item.js";
import J from "../../_mixins/use-config.js";
import T from "../../_mixins/use-theme.js";
import Q from "../../../../../../vooks@0.2.12_vue@3.5.18/node_modules/vooks/es/use-merged-state.js";
import { createKey as y } from "../../_utils/cssr/index.js";
import { useThemeClass as W } from "../../_mixins/use-css-vars-class.js";
import { flatten as X } from "../../_utils/vue/flatten.js";
import { getSlot as Y } from "../../_utils/vue/get-slot.js";
import { warn as Z } from "../../_utils/naive/warn.js";
import oo from "../styles/light.js";
import { call as I } from "../../_utils/vue/call.js";
import { defineComponent as eo, provide as to, computed as _, h as E } from "../../../../../../@vue_runtime-core@3.5.18/node_modules/@vue/runtime-core/dist/runtime-core.esm-bundler.js";
import { ref as x, toRef as S } from "../../../../../../@vue_reactivity@3.5.18/node_modules/@vue/reactivity/dist/reactivity.esm-bundler.js";
function no(o, a, e) {
  var u;
  const t = [];
  let l = !1;
  for (let i = 0; i < o.length; ++i) {
    const d = o[i], s = (u = d.type) === null || u === void 0 ? void 0 : u.name;
    if (s === "RadioButton" && (l = !0), process.env.NODE_ENV !== "production" && l && s !== "RadioButton") {
      Z("radio-group", "`n-radio-group` in button mode only takes `n-radio-button` as children.");
      continue;
    }
    const m = d.props;
    if (s !== "RadioButton") {
      t.push(d);
      continue;
    }
    if (i === 0)
      t.push(d);
    else {
      const b = t[t.length - 1].props, g = a === b.value, f = b.disabled, h = a === m.value, p = m.disabled, C = (g ? 2 : 0) + (f ? 0 : 1), B = (h ? 2 : 0) + (p ? 0 : 1), F = {
        [`${e}-radio-group__splitor--disabled`]: f,
        [`${e}-radio-group__splitor--checked`]: g
      }, V = {
        [`${e}-radio-group__splitor--disabled`]: p,
        [`${e}-radio-group__splitor--checked`]: h
      }, v = C < B ? V : F;
      t.push(E("div", {
        class: [`${e}-radio-group__splitor`, v]
      }), d);
    }
  }
  return {
    children: t,
    isButtonGroup: l
  };
}
const ro = Object.assign(Object.assign({}, T.props), {
  name: String,
  value: [String, Number, Boolean],
  defaultValue: {
    type: [String, Number, Boolean],
    default: null
  },
  size: String,
  disabled: {
    type: Boolean,
    default: void 0
  },
  "onUpdate:value": [Function, Array],
  onUpdateValue: [Function, Array]
}), Vo = eo({
  name: "RadioGroup",
  props: ro,
  setup(o) {
    const a = x(null), {
      mergedSizeRef: e,
      mergedDisabledRef: u,
      nTriggerFormChange: t,
      nTriggerFormInput: l,
      nTriggerFormBlur: i,
      nTriggerFormFocus: d
    } = q(o), {
      mergedClsPrefixRef: s,
      inlineThemeDisabled: m,
      mergedRtlRef: b
    } = J(o), g = T("Radio", "-radio-group", L, oo, o, s), f = x(o.defaultValue), h = S(o, "value"), p = Q(h, f);
    function C(n) {
      const {
        onUpdateValue: r,
        "onUpdate:value": R
      } = o;
      r && I(r, n), R && I(R, n), f.value = n, t(), l();
    }
    function B(n) {
      const {
        value: r
      } = a;
      r && (r.contains(n.relatedTarget) || d());
    }
    function F(n) {
      const {
        value: r
      } = a;
      r && (r.contains(n.relatedTarget) || i());
    }
    to(M, {
      mergedClsPrefixRef: s,
      nameRef: S(o, "name"),
      valueRef: p,
      disabledRef: u,
      mergedSizeRef: e,
      doUpdateValue: C
    });
    const V = K("Radio", b, s), v = _(() => {
      const {
        value: n
      } = e, {
        common: {
          cubicBezierEaseInOut: r
        },
        self: {
          buttonBorderColor: R,
          buttonBorderColorActive: w,
          buttonBorderRadius: z,
          buttonBoxShadow: $,
          buttonBoxShadowFocus: D,
          buttonBoxShadowHover: G,
          buttonColor: U,
          buttonColorActive: k,
          buttonTextColor: A,
          buttonTextColorActive: N,
          buttonTextColorHover: H,
          opacityDisabled: O,
          [y("buttonHeight", n)]: P,
          [y("fontSize", n)]: j
        }
      } = g.value;
      return {
        "--n-font-size": j,
        "--n-bezier": r,
        "--n-button-border-color": R,
        "--n-button-border-color-active": w,
        "--n-button-border-radius": z,
        "--n-button-box-shadow": $,
        "--n-button-box-shadow-focus": D,
        "--n-button-box-shadow-hover": G,
        "--n-button-color": U,
        "--n-button-color-active": k,
        "--n-button-text-color": A,
        "--n-button-text-color-hover": H,
        "--n-button-text-color-active": N,
        "--n-height": P,
        "--n-opacity-disabled": O
      };
    }), c = m ? W("radio-group", _(() => e.value[0]), v, o) : void 0;
    return {
      selfElRef: a,
      rtlEnabled: V,
      mergedClsPrefix: s,
      mergedValue: p,
      handleFocusout: F,
      handleFocusin: B,
      cssVars: m ? void 0 : v,
      themeClass: c == null ? void 0 : c.themeClass,
      onRender: c == null ? void 0 : c.onRender
    };
  },
  render() {
    var o;
    const {
      mergedValue: a,
      mergedClsPrefix: e,
      handleFocusin: u,
      handleFocusout: t
    } = this, {
      children: l,
      isButtonGroup: i
    } = no(X(Y(this)), a, e);
    return (o = this.onRender) === null || o === void 0 || o.call(this), E("div", {
      onFocusin: u,
      onFocusout: t,
      ref: "selfElRef",
      class: [`${e}-radio-group`, this.rtlEnabled && `${e}-radio-group--rtl`, this.themeClass, i && `${e}-radio-group--button-group`],
      style: this.cssVars
    }, l);
  }
});
export {
  Vo as default,
  ro as radioGroupProps
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/naive-ui@2.42.0_vue@3.5.18/~/naive-ui/es/radio/src/RadioGroup.js
// module id = 102
// module chunks = 41